import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

export default function AuthCallback() {
    const { handleGoogleCallback, user } = useAuth();
    const navigate = useNavigate();
    const hasProcessed = useRef(false);

    useEffect(() => {
        // Prevent double processing in StrictMode
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const processCallback = async () => {
            const hash = window.location.hash;
            const sessionIdMatch = hash.match(/session_id=([^&]+)/);
            
            if (sessionIdMatch) {
                const sessionId = sessionIdMatch[1];
                try {
                    const userData = await handleGoogleCallback(sessionId);
                    // Clear the hash
                    window.history.replaceState(null, '', window.location.pathname);
                    
                    // Navigate based on role
                    if (userData.role === 'admin') {
                        navigate('/admin', { state: { user: userData }, replace: true });
                    } else if (userData.role === 'officer') {
                        navigate('/officer', { state: { user: userData }, replace: true });
                    } else {
                        navigate('/dashboard', { state: { user: userData }, replace: true });
                    }
                } catch (error) {
                    console.error('Google auth failed:', error);
                    navigate('/', { replace: true });
                }
            } else {
                navigate('/', { replace: true });
            }
        };

        processCallback();
    }, [handleGoogleCallback, navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-background">
            <div className="flex flex-col items-center gap-4">
                <Loader2 className="w-10 h-10 animate-spin text-primary" />
                <p className="text-lg text-muted-foreground">Completing sign in...</p>
            </div>
        </div>
    );
}
